import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsDetailOverviewView } from './overview/overview';

export const ProgramsDetailView = angular
  .module('acme.view.application.programs.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.programs.detail.controllers',
    'acme.common.directive.pageHeader',
    'acme.common.directive.detailHeader',
    'acme.common.directive.resourceType',
    'acme.common.service.api',
    ProgramsDetailOverviewView,
    'acme.view.application.programs.detail.photos',
    'acme.view.application.programs.detail.dependents',
    'acme.view.application.programs.detail.chart',
    'acme.view.application.programs.detail.upsells',
  ])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default

    $stateProvider.state({
      name: 'application.programsDetail',
      url: '/programs/detail/:id',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'ProgramsDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Event Template',
        permissions: ['EVENT_TEMPLATE_VIEW'],
      },
      resolve: {
        ResolveViewData: [
          '$stateParams',
          'ApiService',
          function ($stateParams: StateParams, ApiService: ApiService) {
            return ApiService.program.get($stateParams.id);
          },
        ],
      },
    });
  }).name;
